import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  FaMobileAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';

import Footer from '../Components/Footer';
import Header from '../Components/Header';

const initialFormData = {
  name: '',
  phone: '',
  location: '',
  email: '',
  message: '',
};

function Contact() {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    const payload = new FormData();
    payload.append('name', formData.name);
    payload.append('phone', formData.phone);
    payload.append('location', formData.location);
    payload.append('email', formData.email);
    payload.append('message', formData.message);
    payload.append('_subject', 'New enquiry from Mobile Acc');
    payload.append('_captcha', 'false');
    payload.append('_template', 'table');

    try {

      const response = await fetch(
        "https://aadikaash.com/backend/wp-json/custom/v1/enquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (result.status !== "success") {
        throw new Error(result.message);
      }

      setStatus({
        type: 'success',
        message:
          'Your enquiry has been sent successfully. We will get back to you soon.',
      });
      setFormData(initialFormData);
    } catch (error) {
      setStatus({
        type: 'error',
        message:
          error.message ||
          'Something went wrong while sending your enquiry. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* <Helmet>
        <title>The Picture Valley | Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA</title>
        <meta
          name="description"
          content="Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA"
        />
        <meta
          name="keywords"
          content="Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA"
        />
      </Helmet> */}

      <Header />

      <div className="container main-contant contact-content">
        <div className="inner-page-container">
          <div className="contact-page">
            <div className="row contact-layout">
              <div className="col-lg-6">
                <div className="contact-form-panel">
                  <div className="contact-form-header">
                    <h2>Send Us a Message</h2>
                  </div>

                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="contact-form-group">
                      <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Name (required)*"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="contact-form-group">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Email (required)*"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="contact-form-group">
                      <input
                        id="phone"
                        name="phone"
                        type="tel"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="contact-form-group">
                      <input
                        id="location"
                        name="location"
                        type="text"
                        placeholder="Location"
                        value={formData.location}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-group">
                      <textarea
                        id="message"
                        name="message"
                        rows="5"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {status.message ? (
                      <div
                        className={`contact-form-status ${status.type === 'success'
                            ? 'contact-form-status-success'
                            : 'contact-form-status-error'
                          }`}
                      >
                        {status.message}
                      </div>
                    ) : null}

                    <button
                      className="contact-submit-btn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="contact-info-panel">
                  <div className="contact-info-header">
                    <h2>Contact Us</h2>
                  </div>

                  <div className="contact-info-grid">
                  

                    <div className="contact-info-card contact-info-card-minimal">
                      <div className="contact-info-icon">
                        <FaMapMarkerAlt />
                      </div>
                      <div>
                        <h3>Location</h3>
                         <p>Bldg No. 2682 Basement, Street No. 2 Gurudwara Road , New Delhi - 110005</p>                      
                      </div>
                    </div>

                    <div className="contact-info-card contact-info-card-minimal">
                      <div className="contact-info-icon">
                        <FaMobileAlt />
                      </div>
                      <div>
                        <h3>Call Center</h3>
                        <p>
                         <a href="tel:+91 98102 96709">+91 98102 96709</a>
                        </p>                      
                      </div>
                    </div>

                    <div className="contact-info-card contact-info-card-minimal">
                      <div className="contact-info-icon">
                        <FaEnvelope />
                      </div>
                      <div>
                        <h3>Email Us</h3>
                        <p>
                          <a href="mailto:info@mobileacc.in">
                          info@mobileacc.in
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
